module.exports = __webpack_public_path__ + "static/media/org_level.da4c5ba2.svg";